import { render, staticRenderFns } from "./common-intents.vue?vue&type=template&id=5b50f19c&scoped=true"
import script from "./common-intents.ts?vue&type=script&lang=ts&external"
export * from "./common-intents.ts?vue&type=script&lang=ts&external"
import style0 from "./common-intents.less?vue&type=style&index=0&id=5b50f19c&prod&lang=less&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b50f19c",
  null
  
)

export default component.exports